export function toggleCart() {
  const cart = document.querySelector('.cart');
  if (cart.classList.contains('is-hidden')) {
    showCart();
  } else {
    closeCart();
  }
}

export function showCart() {
  const cart = document.querySelector('.cart');
  cart.classList.remove('is-hidden');
  document.documentElement.classList.add('noscroll');
  document.querySelectorAll('.nav-main').forEach(function(toggle) {
        toggle.classList.toggle('extended-open');
      });
  
}

function closeCart() {
  const cart = document.querySelector('.cart');
  cart.classList.add('is-hidden');
  document.documentElement.classList.remove('noscroll');
   document.querySelectorAll('.nav-main').forEach(function(toggle) {
        toggle.classList.toggle('extended-open');
      });
}

document.addEventListener('click', (event) => {
  if (event.target.matches('.cart__iframe-wrap__close')) {
    toggleCart();
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const cart = document.querySelector('.cart');
  const nav = document.querySelector('.nav-main');

  if (!cart || !nav) {
    console.warn('Required elements (.cart or .nav-main) are missing.');
    return;
  }

  const updateCartHeightAndPos = () => {
    const navBottom = nav.getBoundingClientRect().bottom;
    const viewportHeight = window.innerHeight;
    const cartHeight = viewportHeight - navBottom;

    //cart.style.height = `${cartHeight}px`;
    //cart.style.top = navBottom + 'px';
  };

  // Update height on load and scroll
  updateCartHeightAndPos();
  window.addEventListener('scroll', updateCartHeightAndPos);
  window.addEventListener('resize', updateCartHeightAndPos);
});


